const SECTIONS = {
    DASHBOARD: "DASHBOARD",
    SOW: "SOW",
    UPSELL: "UPSELL",
    EDIT_SALES: "EDIT_SALES",
    INVOICES: "INVOICES",
    DO_YOU_HAVE_UPSELL: "DO_YOU_HAVE_UPSELL",
    DO_YOU_HAVE_SERVICE: "DO_YOU_HAVE_SERVICE",
    FINAL_DASHBOARD: "FINAL_DASHBOARD",
    THANK_YOU: "THANK_YOU",
    NO_ACTIONS: "NO_ACTIONS",
    EDIT_KICK_OFF_LINE_ITEM: "EDIT_KICK_OFF_LINE_ITEM",
    DO_YOU_HAVE_SERVICE_WITHOUT_SOW: "DO_YOU_HAVE_SERVICE_WITHOUT_SOW",
    EDIT_SALE_LINE_ITEM: "EDIT_SALE_LINE_ITEM",
    NO_SERVICE_PROVIDED: "NO_SERVICE_PROVIDED",
    HYSTORICAL_DATA: "HYSTORICAL_DATA",
    UPLOAD_LATER_SOW: "UPLOAD_LATER_SOW",
    THANK_YOU_UPLOAD_SOW: "THANK_YOU_UPLOAD_SOW",
};

export { SECTIONS };
